<template>
  <div id="app-container">
    <h1>API Call Test Page</h1>
    <hr>

    <div>
      <h2>DateTime API Call</h2>
      <p v-if="loading">Status: Fetching data...</p>
      <p v-if="error" class="error">Status: An error occurred.</p>
      <p v-if="dateTime" class="success">Status: Success!</p>

      <div v-if="error">
        <h3>Error Details:</h3>
        <p>{{ error }}</p>
        <button @click="fetchDateTime">Try Again</button>
      </div>

      <div v-if="dateTime">
        <h3>Response Data:</h3>
        <p><strong>Raw Data:</strong> {{ dateTime }}</p>
        <p><strong>Formatted:</strong> {{ formattedDateTime }}</p>
      </div>
    </div>

    <div v-if="dateTime && !error">
      <hr>
      <h2>Login API Call</h2>
      <p v-if="loginLoading">Status: Authenticating...</p>
      <p v-if="loginError" class="error">Status: Login failed.</p>
      <p v-if="loginResponse" class="success">Status: Login Success!</p>

      <div v-if="loginError">
        <h3>Login Error Details:</h3>
        <p>{{ loginError }}</p>
      </div>

      <div v-if="loginResponse">
        <h3>Login Response Data:</h3>
        <pre>{{ JSON.stringify(loginResponse, null, 2) }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
// Build-time: target Chrome 38 with Babel, include core-js/regenerator polyfills, and set publicPath: './' in vue.config.js so assets resolve on webOS.
import { fetchDateTime as apiFetchDateTime, login as apiLogin } from './services/apiClient';

export default {
  name: 'App',
  data: function() {
    return {
      dateTime: null,
      loading: true,
      error: null,
      uniqueId: null,
      loginLoading: false,
      loginError: null,
      loginResponse: null,

      // Optional: point to a same-origin proxy to avoid TV CORS; set to '' to hit remote API directly.
      proxyBase: '' // e.g., '/api'
    };
  },
  computed: {
    formattedDateTime: function() {
      if (!this.dateTime) return '';
      try {
        var d = new Date(this.dateTime);
        return isNaN(d.getTime()) ? 'Invalid Date' : d.toLocaleString();
      } catch (e) {
        return 'Invalid Date';
      }
    }
  },
  mounted: function() {
    this.fetchDateTime();
  },
  methods: {
    async fetchDateTime() {
      this.loading = true;
      this.error = null;
      this.dateTime = null;
      try {
        const dt = await apiFetchDateTime({ proxyBase: this.proxyBase });
        this.dateTime = dt;
        await this.performLogin();
      } catch (e) {
        this.error = e && e.message ? e.message : 'Unknown error';
      } finally {
        this.loading = false;
      }
    },

    async performLogin() {
      this.loginLoading = true;
      this.loginError = null;
      this.loginResponse = null;
      try {
        const result = await apiLogin({
          proxyBase: this.proxyBase,
          uniqueId: this.uniqueId // preserve stable device ID if already created
        });
        this.uniqueId = result.uniqueId; // persist the generated/used ID
        this.loginResponse = result.data;
        if (result.status < 200 || result.status >= 300) {
          this.loginError = 'Login server responded with status: ' + result.status;
        }
      } catch (e) {
        this.loginError = e && e.message ? e.message : 'Unknown error';
      } finally {
        this.loginLoading = false;
      }
    }
  }
};
</script>

<style>
body { font-family: sans-serif; padding: 20px; background-color: #f0f0f0; }
#app-container { background-color: #fff; padding: 20px; border: 1px solid #ccc; }
.error { color: red; font-weight: bold; }
.success { color: green; font-weight: bold; }
pre {
  background-color: #eee;
  padding: 10px;
  border-radius: 4px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
